import { render } from "./EventPreviewComponent.vue?vue&type=template&id=c2183a12&scoped=true&ts=true"
import script from "./EventPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./EventPreviewComponent.vue?vue&type=script&lang=ts"

import "./EventPreviewComponent.vue?vue&type=style&index=0&id=c2183a12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2183a12"]])

export default __exports__